<main class="container" style="min-height: 73vh">
  <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">
    <div class="row">
      <div class="col col-12">
        <h2>Group Information</h2>

        <div class="instance-row">
          <label for="instanceSelect">Instance</label>
          <select id="instanceSelect" [(ngModel)]="selectedInstance" (ngModelChange)="onInstanceChange()">
            <option *ngFor="let instance of instances" [value]="instance">{{ instance }}</option>
          </select>
        </div>

        <div class="dashboard-layout">
          <aside class="group-list-panel">
            <h3>Groups</h3>
            <ul>
              <li
                *ngFor="let group of groups"
                (click)="selectGroup(group)"
                [class.selected]="group.name === selectedGroup"
              >
                {{ group.name }}
              </li>
            </ul>
          </aside>

          <section class="details-panel">
            <h3>Group Details</h3>

            <p *ngIf="!selectedGroup" class="empty-state">Select a group to view details.</p>
            <p *ngIf="loadingDetails" class="loading-state">Loading group details...</p>
            <p *ngIf="errorMessage" class="error-message">{{ errorMessage }}</p>

            <div *ngIf="selectedGroup && !loadingDetails && details && !errorMessage">
              <div class="details-section">
                <h4>Summary</h4>
                <div class="summary-grid">
                  <div class="summary-item">
                    <span class="summary-label">Name</span>
                    <span class="summary-value">{{ groupName || selectedGroup }}</span>
                  </div>
                  <div class="summary-item">
                    <span class="summary-label">ID</span>
                    <span class="summary-value mono">{{ groupId || '-' }}</span>
                  </div>
                  <div class="summary-item summary-item-full">
                    <span class="summary-label">Description</span>
                    <span class="summary-value">{{ groupDescription || '-' }}</span>
                  </div>
                </div>
              </div>

              <div class="details-section" *ngIf="members.length > 0">
                <h4 class="section-heading">Members ({{ members.length }})</h4>
                <div class="details-table-wrapper">
                  <table>
                    <thead>
                      <tr>
                        <th class="index-col">#</th>
                        <th>Member</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let member of members; let i = index">
                        <td class="index-col">{{ i + 1 }}</td>
                        <td class="value-col">{{ member }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="details-section" *ngIf="permissionRows.length > 0">
                <h4 class="section-heading">Permissions</h4>
                <div class="details-table-wrapper">
                  <table>
                    <thead>
                      <tr>
                        <th class="field-col">Permission</th>
                        <th>Allowed</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let permission of permissionRows">
                        <td class="field-col">{{ toDisplayLabel(permission.key) }}</td>
                        <td>
                          <span class="permission-badge" [class.enabled]="permission.value" [class.disabled]="!permission.value">
                            {{ permission.value ? 'Yes' : 'No' }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="details-section" *ngIf="securityProfiles.length > 0">
                <h4 class="section-heading">Security Profiles</h4>
                <div class="details-table-wrapper">
                  <table>
                    <thead>
                      <tr>
                        <th class="field-col">Name</th>
                        <th>ID</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let profile of securityProfiles">
                        <td class="field-col">{{ profile.name }}</td>
                        <td class="value-col mono">{{ profile.id }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="details-section" *ngIf="securityTypes.length > 0">
                <h4 class="section-heading">Security Types</h4>
                <div class="details-table-wrapper">
                  <table>
                    <thead>
                      <tr>
                        <th class="field-col">Name</th>
                        <th>ID</th>
                        <th class="status-col">Delete Entity</th>
                        <th class="status-col">Read Only</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let securityType of securityTypes">
                        <td class="field-col">{{ securityType.name }}</td>
                        <td class="value-col mono">{{ securityType.id }}</td>
                        <td class="status-col">{{ securityType.deleteEntity ? 'Yes' : 'No' }}</td>
                        <td class="status-col">{{ securityType.readOnly ? 'Yes' : 'No' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="details-section" *ngIf="additionalRows.length > 0">
                <h4>Additional Data</h4>
                <div class="details-table-wrapper">
                  <table>
                    <thead>
                      <tr>
                        <th class="field-col">Field</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of additionalRows">
                        <td class="field-col">{{ toDisplayLabel(row.key) }}</td>
                        <td class="value-col">{{ row.value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</main>
